import { render } from "./index.vue?vue&type=template&id=0101a0aa&scoped=true"
import script from "./radio-button-group.ts?vue&type=script&lang=js"
export * from "./radio-button-group.ts?vue&type=script&lang=js"

import "./radio-button-group.scss?vue&type=style&index=0&id=0101a0aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0101a0aa"

export default script